import { Row } from 'antd';
import styled from 'styled-components';

export const AlertHistoryMetaPanel = styled.div`
  background: #fff;
  border-radius: 5px;
  padding: 30px;
  box-shadow: 1px 1px 2px rgba(0, 0, 0, 0.25);
`;

export const AlertHistoryMetaPanelTitle = styled.div`
  font-weight: 500;
  font-size: 14px;
  line-height: 16px;
`;

export const MetaDataWrapper = styled(Row)`
  margin-top: 20px;
`;

export const MetaDataBox = styled.div`
  padding: 36px 32px;
  background: #f7f7f8;
  border-radius: 4px;
`;

export const AlertsCountLabel = styled.div`
  color: #e84d42;
  font-size: 40px;
  font-weight: 500;
`;

export const SarsCountLabel = styled.div`
  color: #748aa1;
  font-size: 40px;
  font-weight: 500;
`;

export const FlexWrapper = styled.div`
  display: flex;
  align-items: center;
`;

export const CountDescriptionLabel = styled.div`
  color: #31394d;
  font-size: 14px;
  line-height: 18px;
`;

export const ViewTypologiesLink = styled.button`
  color: #0c8ed7;
  font-size: 12px;
  line-height: 22px;
  margin-left: 20px;
`;
